import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input } from 'reactstrap';

const OpenCashierModal = ({ isOpen, toggle, onConfirm, isProcessing }) => {
    const [openingBalance, setOpeningBalance] = useState(0);

    const handleSubmit = (e) => {
        e.preventDefault();
        onConfirm({
            idBankAccount: "default", // Valor default pois não exige mais escolha na UI
            openingBalance: Number(openingBalance)
        });
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered backdrop="static" className="border-0 shadow">
            <ModalHeader toggle={toggle} className="border-bottom pb-3">
                <span className="fw-bold text-dark font-size-15">
                    <i className="mdi mdi-cash-register text-primary me-2"></i>
                    Abertura de Caixa
                </span>
            </ModalHeader>
            <Form onSubmit={handleSubmit}>
                <ModalBody>
                    <p className="text-muted mb-4">
                        O processo de abertura marca o início de um novo turno de trabalho. 
                        Defina com qual saldo inicial (fundo de troco) você está começando.
                    </p>

                    <FormGroup className="mb-0">
                        <Label className="fw-medium">Fundo de Troco Inicial (R$)</Label>
                        <Input
                            id="opening-balance-input"
                            name="openingBalance"
                            type="number"
                            className="form-control form-control-lg text-end fs-4 text-primary"
                            placeholder="0,00"
                            min="0"
                            step="0.01"
                            value={openingBalance}
                            onChange={(e) => setOpeningBalance(e.target.value || 0)}
                            autoComplete="off"
                        />
                        <small className="text-muted d-block mt-1">Este valor representa as cédulas já presentes na gaveta antes de qualquer venda.</small>
                    </FormGroup>
                </ModalBody>
                <ModalFooter className="border-top pt-3">
                    <Button color="light" className="text-muted fw-semibold" onClick={toggle} disabled={isProcessing}>
                        Cancelar
                    </Button>
                    <Button color="primary" type="submit" disabled={isProcessing} className="fw-semibold px-4 shadow">
                        {isProcessing ? 'Abrindo...' : 'Abrir Caixa'}
                    </Button>
                </ModalFooter>
            </Form>
        </Modal>
    );
};

export default OpenCashierModal;
